// frontend/src/pages/SolutionMatches.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../services/axios';
import toast from 'react-hot-toast';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const SolutionMatches = () => {
    const [loading, setLoading] = useState(true);
    const [matches, setMatches] = useState([]);

    useEffect(() => {
        loadMatches();
    }, []);

    const loadMatches = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/solutions/my-matches');
            setMatches(response.data.data || []);
        } catch (error) {
            toast.error('Failed to load solution matches');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-gray-600">Loading matched solutions...</div>
            </div>
        );
    }

    return (
        <div className="w-full space-y-6">
            <Link to="/solutions" className="inline-flex items-center text-sm text-gray-600 hover:text-black space-x-1">
                <ArrowLeftIcon className="w-4 h-4" />
                <span>Back to Solutions Catalog</span>
            </Link>

            <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
                <h1 className="text-2xl font-bold text-gray-900">My Solution Matches</h1>
                <p className="text-sm text-gray-600 mt-1">
                    Track solution matches created for your business assessment projects.
                </p>
            </div>

            {matches.length === 0 ? (
                <div className="bg-white rounded-lg border border-gray-200 p-12 text-center space-y-3">
                    <p className="text-gray-500">No solutions matched to your business projects yet.</p>
                    <Link
                        to="/solutions"
                        className="inline-block px-4 py-2 bg-black text-white text-sm font-medium rounded-md hover:bg-gray-800"
                    >
                        Browse Solutions Library
                    </Link>
                </div>
            ) : (
                <div className="space-y-4">
                    {matches.map((match) => (
                        <div key={match.id} className="bg-white border border-gray-200 rounded-lg p-6 flex justify-between items-start flex-wrap gap-4">
                            <div>
                                <div className="flex items-center space-x-3">
                                    <h3 className="text-lg font-bold text-gray-900">
                                        {match.solution?.name || 'Matched Solution'}
                                    </h3>
                                    <span className="px-2.5 py-0.5 text-xs font-semibold rounded-full bg-blue-50 text-blue-700 capitalize">
                                        {match.status}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-600 mt-1">
                                    {match.solution?.description}
                                </p>
                                {match.assessment?.business && (
                                    <p className="text-xs text-gray-500 mt-2">
                                        Matched for: <span className="font-medium text-gray-700">{match.assessment.business.name}</span>
                                    </p>
                                )}
                            </div>
                            <Link
                                to={`/solutions/${match.solution_id}`}
                                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
                            >
                                View Details & Training
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SolutionMatches;
